import { IMAGES } from "../../../images";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { useEffect, useState } from "react";
import {
  AddScheduleMeeting,
  EditScheduleMeeting,
} from "../../../../components/VideoCall";
import { PATH } from "../../../../config";
import { useLocation } from "react-router-dom";

function PageContent({ children }) {
  const location = useLocation();
  return (
    <div className={`child-custom-layout ${location.pathname == PATH.HOME ? "mt-0" : "child-custom-layout"}`}>
      <div>
        <div className=" p-0 w-100 h-100">
          <div className="site-layout-background">{children}</div>
        </div>
      </div>
    </div>
  );
}
export default PageContent;
